export default `
<div class="dashboard-card-list">
  <div role="list" aria-label="Projects" ng-if="$ctrl.projects.length > 0">
    <dashboard-activity-project-list-item role="listitem" project="project" item-type="project" tester-app-url="{{$ctrl.profile_url}}" ng-repeat="project in $ctrl.projects"></dashboard-activity-project-list-item>
  </div>
  <dashboard-activity-project-list-footer item-count="{{$ctrl.projectsCount}}" item-type="project" tester-app-url="{{$ctrl.profile_url}}" ng-if="$ctrl.projectsCount > 5"></dashboard-activity-project-list-footer>
  <dashboard-activity-project-empty-list-notification have-no="active or pending projects" ng-if="$ctrl.projectsCount == 0"></dashboard-activity-project-empty-list-notification>
</div>
`;
